export default "__VITE_ASSET__Dk2OwtPp__"